import {decorate, inject, injectable} from '@yosmanyga/di';
import {action, observable, runInAction, makeObservable} from 'mobx';
import {ConfigManager} from '@yosmanyga/base';
import {FeedbackApi, MessageContentType, MessageIndexType} from '../data';

class FeedbackController {
    loaded: boolean;
    sending: boolean;
    indexes: Array<MessageIndexType>;
    contents: Array<MessageContentType>;
    input: string;

    constructor(
        private feedbackApi: FeedbackApi,
        private configManager: ConfigManager
    ) {
        this.loaded = false;
        this.sending = false;
        this.indexes = [];
        this.contents = [];
        this.input = '';
        
        makeObservable(this, {
            loaded: observable,
            sending: observable,
            indexes: observable,
            contents: observable,
            input: observable,
            load: action,
            prepare: action,
            send: action,
        });
    }

    load = async () => {
        const indexes = await this.feedbackApi.collectMessageIndexes();

        const ids = indexes.map(({message}) => message);

        const contents = await this.feedbackApi.collectMessageContents(ids || []);

        // Last time feedback was read
        await this.configManager.set(
            'feedback_read',
            Math.floor(Date.now() / 1000).toString()
        );

        runInAction(() => {
            this.indexes = indexes;
            this.contents = contents;
            this.loaded = true;
        });
    };

    prepare = (value: string) => {
        runInAction(() => {
            this.input = value;
        });
    };

    send = async () => {
        const input = this.input;

        runInAction(() => {
            this.input = '';

            this.sending = true;
        });

        await this.feedbackApi.sendMessage(input);

        runInAction(() => {
            this.sending = false;
        });

        await this.load();
    };
}

decorate(injectable(), FeedbackController);
decorate(inject(FeedbackApi), FeedbackController, 0);
decorate(inject(ConfigManager), FeedbackController, 1);

export {FeedbackController};
